export default __webpack_public_path__ + "static/dan@2x-a5547486e210b1b42446b7477b97ecf6.jpg";